/* eslint-disable */
export function setSessionStorageItem(key, value) {
  // Convert value to JSON before storing
  let jsonValue = JSON.stringify(value);
  // Set item in sessionStorage
  sessionStorage.setItem(key, jsonValue);
}
/* eslint-enable */
export const getSessionStorageItem = (key) => {
  // Retrieve item from sessionStorage
  let jsonValue = sessionStorage.getItem(key);
  // Parse JSON value if found
  return jsonValue ? JSON.parse(jsonValue) : {};
};
